<template>
    <footer class="flex flex-row-reverse no-underline text-gray-400 pl-2 pr-2 mt-2">
        <button
            v-if="showExpandButton"
            ref="expandButton"
            class="hover:text-dark-blue-400 ml-4 cursor-pointer text-2xl"
            @click="toggleModal"
            aria-label="Expand"
            title="Expand"
        >
            <span class="hidden">Expand</span>
            <font-awesome-icon :icon="['fad', 'info-circle']" class="myvb_info_circle_icon" />
        </button>
        <button
            v-if="link"
            ref="linkButton"
            class="hover:text-dark-blue-400 ml-4 cursor-pointer text-2xl"
            @click="openLink(link)"
            aria-label="Open in Browser"
            title="Open in Browser"
        >
            <span class="hidden">Open in Browser</span>
            <font-awesome-icon :icon="['far', 'external-link']" class="myvb_info_icons" />
        </button>
    </footer>
</template>

<script>
import { Capacitor } from "@capacitor/core"
import { Browser } from "@capacitor/browser"
import { Share } from "@capacitor/share"
import { App } from "@capacitor/app"

export default {
    name: "CardFooter",
    props: {
        showExpandButton: {
            required: false,
            type: Boolean,
            default: false,
        },
        link: {
            required: false,
            type: String,
        },
        appStoreLink: {
            required: false,
            type: String,
        },
        playStoreLink: {
            required: false,
            type: String,
        },
        urlScheme: {
            required: false,
            type: String,
        },
    },
    data() {
        return {
            canOpenUrlScheme: false,
        };
    },
    computed: {
        /**
         * Gets the current platform
         *
         * @returns the current platform
         */
        platform: function() {
            return Capacitor.platform;
        },
    },
    methods: {
        /**
         * Opens the link url in a new window or external browser
         */
        openLink: function(link) {
            this.$emit("openedLink");
            Browser.open({ url: link });
        },
        /**
         * Opens the share sheet and sends a link
         */
        shareLink: function() {
            Share.share({
                url: this.link,
            });
            this.$emit("sharedLink");
        },
        /**
         * Toggles the modal on/off
         */
        toggleModal: function() {
            this.$emit("toggleModal");
        },
        /**
         * Launches the native app
         */
        launchUrlScheme: function() {
            App.openUrl({ url: this.urlScheme });
        },
    },
};
</script>
